export default "__VITE_ASSET__DCOjSBtV__"